import { DIRECTORY_PAGE_LIMIT } from "./prerenderData";

export function realEstateListKey({ search = "", type = "", status = "" } = {}) {
  return `real-estate:list:${search}:${type}:${status}:${DIRECTORY_PAGE_LIMIT}`;
}

export function warpsListKey({ search = "", type = "" } = {}) {
  return `warps:list:${search}:${type}:${DIRECTORY_PAGE_LIMIT}`;
}

export function blogListKey({ topic = "", tag = "" } = {}) {
  return `blog:list:${topic}:${tag}`;
}

export function blogPostKey(slug) {
  return `blog:post:${slug}`;
}

export function warpDetailKey(id) {
  return `warps:detail:${id}`;
}

export function realEstateDetailKey(id) {
  return `real-estate:detail:${id}`;
}

export const MARKETS_ALL_TIME_KEY = "markets:tsv:all-time-avg";
export const MARKETS_MONTHLY_KEY = "markets:tsv:all-time-by-month";

export function forumHomeKey() {
  return "forum:home";
}

export function forumBoardKey(boardId) {
  return `forum:board:${boardId}`;
}

export function forumCategoryKey(categoryId, page = 1) {
  return `forum:category:${categoryId}:${page}`;
}

export function forumThreadKey(threadId, page = 1) {
  return `forum:thread:${threadId}:${page}`;
}

export function forumNotificationsKey() {
  return "forum:notifications";
}

export function forumProfileKey() {
  return "forum:profile";
}

export function playerProfileKey(webUsername) {
  return `profile:${webUsername}`;
}

export function supportTicketsKey(all = false) {
  return `support:tickets:${all ? "all" : "mine"}`;
}

export function supportAppealsKey(all = false) {
  return `support:appeals:${all ? "all" : "mine"}`;
}

export function supportTicketDetailKey(id) {
  return `support:ticket:${id}`;
}

export function supportAppealDetailKey(id) {
  return `support:appeal:${id}`;
}

export function messagesListKey() {
  return "messages:list";
}

export function messagesThreadKey(threadId) {
  return `messages:thread:${threadId}`;
}

export function submissionsKey() {
  return "submissions:mine";
}

export function userSubmissionsKey(page = 1) {
  return `submissions:approved:${page}`;
}

export function myUploadKey() {
  return "uploads:mine";
}

export function adminDashboardKey() {
  return "admin:dashboard";
}

const HOME_PREVIEW_LIMIT = 6;

export function homeWarpsPreviewKey(limit = HOME_PREVIEW_LIMIT) {
  return `warps:preview:${limit}`;
}

export function homeSubmissionsPreviewKey(limit = HOME_PREVIEW_LIMIT) {
  return `submissions:preview:${limit}`;
}

export function tournamentsListKey({ status = "" } = {}) {
  return `tournaments:list:${status}`;
}

export function tournamentDetailKey(slug) {
  return `tournaments:detail:${slug}`;
}
